import { SID } from "@securitize/domain";
import {
  entityTypesTranslations,
  TranslationKey,
} from "../../../../contexts/I18nContext/translationKeys";

export const allowedEntityTypes: SID.InvestorEntityType[] = [
  SID.InvestorEntityTypes.CORPORATION,
  SID.InvestorEntityTypes.LLC,
  SID.InvestorEntityTypes.LIMITED_GENERAL_PARTNERSHIP,
  SID.InvestorEntityTypes.REVOCABLE_TRUST,
  SID.InvestorEntityTypes.IRREVOCABLE_TRUST,
  SID.InvestorEntityTypes.NON_PROFIT_FOUNDATION,
  SID.InvestorEntityTypes.FOR_PROFIT_FOUNDATION,
  SID.InvestorEntityTypes.FUND,
  SID.InvestorEntityTypes.OTHER,
];

export const getDropdownValues = (
  getTranslation: (
    key: TranslationKey,
    replacements?: Record<string, string | number> | undefined,
  ) => string,
) => {
  return Object.values(allowedEntityTypes).map((type) => ({
    value: type,
    label: getTranslation(entityTypesTranslations[type]),
  }));
};
